import React, { act } from "react";
import { Tabs } from "antd";
import PageLayout from "../../UI/PageLayout";
import { CustomerPerformancePageDropdowns } from "./CustomerPerformancePageDropdowns";
import ContentForPage from "../../../containers/ContentForPage";

const { TabPane } = Tabs;

const CustomerPerformancePage = () => {
  const [activeKey, setActiveKey] = React.useState("1");

  const renderTabContent = () => {
    switch (activeKey) {
      case "1":
        return <ContentForPage pageName="customer_performance_overview" />;
      case "2":
        return <ContentForPage pageName="ltr" />;
      case "3":
        return <ContentForPage pageName="cohort" />;;
      case "4":
        return <ContentForPage pageName="ltv_vs_cac" />;
      default:
        return null;
    }
  };

  return (
    <PageLayout
      title={"Customer Performance"}
      dropdowns={<CustomerPerformancePageDropdowns tabKey={activeKey} />}
      content={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          <Tabs activeKey={activeKey} onChange={setActiveKey}>
            <TabPane tab="Overview" key="1" />
            <TabPane tab="LTR" key="2" />
            <TabPane tab="Cohort" key="3" />
            <TabPane tab="LTV vs. CAC" key="4" />
          </Tabs>
          <div>{renderTabContent()}</div>
        </div>
      }
    />
  );
};

export default CustomerPerformancePage;
